/* ============================================================
   FitLibrary — fitlibrary-nr.js
   Product review carousel controller.

   One controller per [data-nr] element, scoped entirely to that
   instance. Native scroll-snap does the swiping; the arrows move
   the track by exactly one card, so the number of cards visible at
   a given breakpoint is a CSS decision and this file never needs
   to know it. No drag handlers, so links and text selection inside
   a card behave normally.

   The only document-level listeners are the Shopify design-mode
   events, bound once behind a global guard.
   ============================================================ */
(function () {
  "use strict";

  if (window.__flNrBound) return;
  window.__flNrBound = true;

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }

  function init(root) {
    if (!root || root.getAttribute("data-nr-ready") === "1") return;

    var track = root.querySelector("[data-nr-track]");
    if (!track) return;

    var prev = root.querySelector("[data-nr-prev]");
    var next = root.querySelector("[data-nr-next]");

    root.setAttribute("data-nr-ready", "1");

    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var cs = window.getComputedStyle(track);
      var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function move(direction) {
      track.scrollBy({
        left: direction * step(),
        behavior: reducedMotion() ? "auto" : "smooth"
      });
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= max;
      var scrollable = max > 2;
      if (prev) { prev.disabled = atStart || !scrollable; }
      if (next) { next.disabled = atEnd || !scrollable; }
    }

    if (prev) {
      prev.addEventListener("click", function (e) { e.preventDefault(); move(-1); });
    }
    if (next) {
      next.addEventListener("click", function (e) { e.preventDefault(); move(1); });
    }

    track.addEventListener("keydown", function (e) {
      if (e.target !== track) return;
      if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
      e.preventDefault();
      move(e.key === "ArrowRight" ? 1 : -1);
    });

    var frame = 0;
    track.addEventListener("scroll", function () {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        sync();
      });
    }, { passive: true });

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { sync(); });
      ro.observe(track);
      root.__flNrObserver = ro;
    } else {
      root.__flNrResize = function () { sync(); };
      window.addEventListener("resize", root.__flNrResize);
    }

    sync();
  }

  function destroy(root) {
    if (!root) return;
    if (root.__flNrObserver) {
      root.__flNrObserver.disconnect();
      root.__flNrObserver = null;
    }
    if (root.__flNrResize) {
      window.removeEventListener("resize", root.__flNrResize);
      root.__flNrResize = null;
    }
    root.removeAttribute("data-nr-ready");
  }

  function initAll(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var found = host.querySelectorAll("[data-nr]");
    for (var i = 0; i < found.length; i++) init(found[i]);
    if (host !== document && host.matches && host.matches("[data-nr]")) init(host);
  }

  function destroyAll(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var found = host.querySelectorAll("[data-nr]");
    for (var i = 0; i < found.length; i++) destroy(found[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
  document.addEventListener("shopify:section:unload", function (e) { destroyAll(e.target); });
})();